export const normalizePhone = (raw: string): string => {
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10 && !digits.startsWith('7')) {
    return `7${digits}`;
  }
  if (
    digits.length === 11 &&
    (digits.startsWith('7') || digits.startsWith('8'))
  ) {
    return `7${digits.slice(1)}`;
  }
  return digits;
};
